import React, { useState, useEffect } from 'react'
import { Button, Paper, TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import formattingStyle from "../../styles/formatting";
import formStyle from "../../styles/forms";
import moment from "moment";
import ProjectService from "../../services/projects";
import Checkbox from '@material-ui/core/Checkbox';
import InvoiceToVisma from "../accounting/invoicetovisma";
import DocumentItems from "../documents/list";
import WorkorderItemService from "../../services/workorderitems";

export default function Conceptinvoice(props) {
    const [orderItems, setOrderItems] = useState(props.orderitems);
    const [showSendVisma, setShowSendVisma] = useState(false);
    const [newReferenceCode, setNewReferenceCode] = useState('');
    const [currentReference, setCurrentReference] = useState('0');
    const [referenceList, setReferenceList] = useState([]);
    const [orderitemsList, setOrderitemsList] = useState();
    const [totalList, setTotalList] = useState(null);

    const [material, setMaterial] = useState('');
    const [materialCost, setMaterialCost] = useState(0);
    const [remarks, setRemarks] = useState('');

    const [makeProjectInactive, setMakeProjectInactive] = useState(false)

    useEffect(() => {
        setOrderItems(props.orderitems)
    }, [props.orderitems])


    const toggleChecked = function (item) {
        let tmpOrderItems = Object.assign([], orderItems);
        tmpOrderItems.forEach(tmpItem => {
            if (item.guid === tmpItem.guid) {
                tmpItem.checked = !tmpItem.checked;
            }
        });
        setOrderItems(tmpOrderItems);
    }

    const setOrderItemsList = () => {

        let tmpOrderitemsList = orderItems.map(item => {
            if ((item.reference === currentReference) || (currentReference === '0' && !item.reference)) {
                return <React.Fragment key={item._id}>
                    <tr><td> <Checkbox
                        checked={item.checked || false}
                        onChange={() => toggleChecked(item)}
                        value={'checked' + item._id}
                        color="primary"
                    /></td><td>{item.user.lastname}, {item.user.firstname}</td><td>{moment(item.date).format('dddd DD MMMM')}</td><td >{item.location === 2 ? "Montage/locatie" : "Werkplaats"}</td><td style={{ textAlign: 'right' }}>{item.kilometers}</td><td style={{ textAlign: 'right' }}>{(item.minutes / 60) || 0}</td><td style={{ textAlign: 'right' }}>{(item.minutesovertime / 60) || 0}</td><td style={{ textAlign: 'right' }}>{(item.raceminutes / 60) || 0}</td><td style={{ textAlign: 'right' }}>{item.nights || 0}</td><td style={{ textAlign: 'right' }}>{item.travelhours || 0}</td></tr>
                    {item.materials && <tr><td></td><td colSpan={8}>{item.materials}</td></tr>}
                    {item.remarks && <tr><td></td><td colSpan={8} >{item.remarks}</td></tr>}
                    {item.attachments && <tr><td></td><td colSpan={8}> <DocumentItems items={item.attachments} readOnly={true} /></td></tr>}
                </React.Fragment>
            } else {
                return null
            }
        })
        setOrderitemsList(tmpOrderitemsList);


    }

    const setMaterialList = () => {
        //material and items
        let tmpTotalRemarks = '';
        let tmpTotalMaterials = '';

        orderItems.forEach(item => {
            if (item.checked) {
                if (item.remarks) tmpTotalRemarks += (item.remarks || '') + '\n';
                if (item.materials) tmpTotalMaterials += (item.materials || '') + '\n';
            }
        })

        setRemarks(tmpTotalRemarks);
        setMaterial(tmpTotalMaterials);
    }

    const handleChangeSelectedReference = (ev) => {
        let tmpOrderItems = Object.assign([], orderItems);
        tmpOrderItems.forEach(tmpItem => {
            tmpItem.checked = false;

        });
        setOrderItems(tmpOrderItems);
        setCurrentReference(ev.target.value);
    }

    const finish = () => {
        let items = orderItems.filter((item) => { return item.checked });
        items = items.map((item) => { item.reference = newReferenceCode; return item });
        props.updateOrderItems(items);
    }

    const handleProjectInactive = () => {
        if (makeProjectInactive === true) {
            let tmpProject = Object.assign({}, props.project);
            tmpProject.inactive = true;
            ProjectService.save(tmpProject);
        }
    }

    useEffect(() => {
        let referenceList = orderItems.map(item => item.reference)
            .filter((value, index, self) => (self.indexOf(value) === index && value))
        referenceList = referenceList.map((item) => {
            return <MenuItem value={item} key={item}>{item}</MenuItem>
        })
        setOrderItemsList();
        setMaterialList();
        //calculateOrderItems();
        setReferenceList(referenceList);

    }, [orderItems, currentReference])

    //calculating totals
    useEffect(() => {
        let tmpList = WorkorderItemService.calculateTotalUsers(orderItems).map((user) => {
            console.log(user.totalRaceMinutes)
            return (
                <React.Fragment key={user._id}>
                    {user.totalKilometers > 0 && <tr><td>Gemaakte kilometers {user.fullName}</td><td style={{ textAlign: 'right' }}>{user.totalKilometers}</td><td style={{ textAlign: 'right' }}>{props.settings['kmvergoeding' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round((user.totalKilometers * props.settings['kmvergoeding' + user.postFix]) * 100, 2) / 100)} </td></tr>}
                    {user.totalTravelHours > 0 && <tr><td>Gemaakte reisuren {user.fullName}</td><td style={{ textAlign: 'right' }}>{user.totalTravelHours}</td><td style={{ textAlign: 'right' }}>{props.settings['reisuren' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round((user.totalTravelHours * props.settings['reisuren' + user.postFix]) * 100, 2) / 100)} </td></tr>}
                    {user.totalNights > 0 && <tr><td>Overnachting {user.fullName}</td><td style={{ textAlign: 'right' }}>{user.totalNights}</td><td style={{ textAlign: 'right' }}>{props.settings['overnachting' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round((user.totalNights * props.settings['overnachting' + user.postFix]) * 100, 2) / 100)} </td></tr>}

                    {user.totalWorkplace > 0 && <tr><td>Gewerkte uren werkplaats {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalWorkplace / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['uurloonwerkplaats' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalWorkplace / 60) * props.settings['uurloonwerkplaats' + user.postFix]) * 100, 2) / 100)} </td></tr>}
                    {user.totalOverhoursWorkplace > 0 && <tr><td>Gewerkte overuren werkplaats  {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursWorkplace / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursWorkplace / 60) * props.settings['uurloonwerkplaats' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td></tr>}

                    {user.totalOverhoursWorkplaceSaturday > 0 && <tr><td>Gewerkte overuren werkplaats zaterdag {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursWorkplaceSaturday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursWorkplaceSaturday / 60) * props.settings['uurloonwerkplaats' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td></tr>}
                    {user.totalOverhoursWorkplaceSunday > 0 && <tr><td>Gewerkte overuren werkplaats zondag{user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursWorkplaceSunday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursWorkplaceSunday / 60) * props.settings['uurloonwerkplaats' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td></tr>}

                    {user.totalLocation > 0 && <tr><td>Gewerkte uren montage/locatie {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalLocation / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['uurloonlocatie' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalLocation / 60) * props.settings['uurloonlocatie' + user.postFix]) * 100, 2) / 100)} </td></tr>}
                    {user.totalOverhoursLocation > 0 && <tr><td>Gewerkte overuren montage/locatie {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursLocation / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursLocation / 60) * props.settings['uurloonlocatie' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td></tr>}

                    {user.totalOverhoursLocationSaturday > 0 && <tr><td>Gewerkte overuren montage/locatie zaterdag {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursLocationSaturday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursLocationSaturday / 60) * props.settings['uurloonlocatie' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td></tr>}
                    {user.totalOverhoursLocationSunday > 0 && <tr><td>Gewerkte overuren montage/locatie zondag {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursLocationSunday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursLocationSunday / 60) * props.settings['uurloonlocatie' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td></tr>}
                 
                    {user.totalRaceMinutes > 0 && <tr><td>Gasgeven {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalRaceMinutes / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['gasgeven' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalRaceMinutes / 60) * props.settings['gasgeven' + user.postFix]) * 100, 2) / 100)} </td></tr>}
                 
                </React.Fragment>
            )
        })
        setTotalList(tmpList)
    }, [orderItems])


    return (
        <div className="padding">
            {props.project._id && <div style={formattingStyle.header} > {'PROJECT: ' + props.project.projectnumber + ' - ' + props.project.name}</div>}
            {(props.project._id && props.project.purchesorders) && <div style={formattingStyle.header} > {'INKOOPNUMMERS: ' + props.project.purchesorders}</div>}
            {props.client._id && <div style={formattingStyle.header} > {'KLANT: ' + props.client.name}</div>}
            {props.project.type && <div style={formattingStyle.header}>{ProjectService.getProjectType(props.project.type)}</div>}
            {showSendVisma && <InvoiceToVisma orderItems={orderItems} project={props.project} client={props.client} settings={props.settings} handleClose={() => { setShowSendVisma(false) }} remarks={remarks} material={material} materialCost={materialCost} />}
            <br />
            <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor="type">Referentienummer:</InputLabel>
                <Select
                    style={formStyle.selectField}
                    value={currentReference}
                    onChange={handleChangeSelectedReference} >
                    <MenuItem value={'0'}>Toon werkbonnen zonder referentienummer</MenuItem>
                    {referenceList}
                </Select>
            </FormControl>
            <br />
            <Paper className="padding">
                <div style={formattingStyle.header} > Uit de werkbonnen</div>
                <table cellPadding="4px" width="100%">
                    <thead><tr><td></td><td>Medewerker</td><td>Datum</td><td>Locatie</td><td style={{ textAlign: 'right' }}>Km</td><td style={{ textAlign: 'right' }}>Tijd (uren)</td><td style={{ textAlign: 'right' }}>Overuren (uren)</td><td style={{ textAlign: 'right' }}>Gasgeven (uren)</td><td style={{ textAlign: 'right' }}>Overnachtingen</td><td style={{ textAlign: 'right' }}>Reisuren</td></tr></thead>
                    <tbody>{orderitemsList}</tbody>
                </table>
                <hr />
                <Checkbox
                    checked={makeProjectInactive || false}
                    onChange={() => setMakeProjectInactive(!makeProjectInactive)}
                    value={'projectinactive'}
                    color="primary"
                />Zet de status van dit project op 'Inactief'
                    <br />
                {currentReference === '0'
                    &&
                    <React.Fragment>

                        <TextField
                            margin="dense"
                            label="Referentie nummer voor aangevinkte werkbonnen"
                            type="text"
                            value={newReferenceCode}
                            onChange={(ev) => setNewReferenceCode(ev.target.value)}
                            fullWidth
                            required
                        />
                        <Button variant="contained" color="primary" onClick={() => { finish(); handleProjectInactive() }} style={{ width: '100%' }} disabled={newReferenceCode.length === 0}>Afronden werkopdrachten</Button>
                    </React.Fragment>
                }
            </Paper>

            <br />
            <Paper className="padding">
                <div style={formattingStyle.header} > Factuurregels</div>
                <table cellPadding="4px" width="100%">
                    <thead><tr><td>Artikelnaam</td><td style={{ textAlign: 'right' }}>Aantal</td><td style={{ textAlign: 'right' }}>Prijs</td><td style={{ textAlign: 'right' }}>Totaal Excl. BTW</td></tr></thead>
                    <tbody>
                        <tr><td>Verrichte werkzaamheden week {WorkorderItemService.getWeekNumbers(orderItems.filter((item) => { return item.checked })).join()}</td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td></tr>

                        {totalList}
                        {/*
                        <tr>
                            <td>Gemaakte kilometers</td><td style={{ textAlign: 'right' }}>{totalKM}</td><td style={{ textAlign: 'right' }}>{props.settings.kmvergoeding}</td><td style={{ textAlign: 'right' }}>{(Math.round((totalKM * props.settings.kmvergoeding) * 100, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Reisuren</td><td style={{ textAlign: 'right' }}>{totalKMHours}</td><td style={{ textAlign: 'right' }}>{props.settings.reisuren}</td><td style={{ textAlign: 'right' }}>{(Math.round((totalKMHours * props.settings.reisuren) * 100, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Overnachting</td><td style={{ textAlign: 'right' }}>{totalNights}</td><td style={{ textAlign: 'right' }}>{props.settings.overnachting}</td><td style={{ textAlign: 'right' }}>{(Math.round((totalNights * props.settings.overnachting) * 100, 2) / 100)} </td>
                        </tr>
                        <tr><td colSpan="4"></td></tr>
                        <tr>
                            <td>Gewerkte uren werkplaats</td><td style={{ textAlign: 'right' }}>{(totalMinutes / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.uurloonwerkplaats}</td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutes / 60) * props.settings.uurloonwerkplaats) * 100, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Gewerkte uren werkplaats overuren</td><td style={{ textAlign: 'right' }}>{(totalMinutesOvertime / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesOvertime / 60) * props.settings.uurloonwerkplaats) * props.settings['overuren' + user.postFix], 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Gewerkte uren werkplaats zaterdag</td><td style={{ textAlign: 'right' }}>{(totalMinutesSaterday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.zaterdag}%  </td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesSaterday / 60) * props.settings.uurloonwerkplaats) * props.settings.zaterdag, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Gewerkte uren werkplaats zondag</td><td style={{ textAlign: 'right' }}>{(totalMinutesSunday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.zondag}%  </td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesSunday / 60) * props.settings.uurloonwerkplaats) * props.settings.zondag, 2) / 100)} </td>
                        </tr>
                        <tr><td colSpan="4"></td></tr>
                        <tr>
                            <td>Gewerkte uren montage/locatie</td><td style={{ textAlign: 'right' }}>{(totalMinutesLocation / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['uurloonlocatie' + user.postFix]}</td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesLocation / 60) * props.settings['uurloonlocatie' + user.postFix]) * 100, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Gewerkte uren montage/locatie overuren</td><td style={{ textAlign: 'right' }}>{(totalMinutesLocationOvertime / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings['overuren' + user.postFix]}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesLocationOvertime / 60) * props.settings['uurloonlocatie' + user.postFix]) * props.settings['overuren' + user.postFix], 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Gewerkte uren montage/locatie zaterdag</td><td style={{ textAlign: 'right' }}>{(totalMinutesLocationSaterday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.zaterdag}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesLocationSaterday / 60) * props.settings['uurloonlocatie' + user.postFix]) * props.settings.zaterdag, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td>Gewerkte uren montage/locatie zondag</td><td style={{ textAlign: 'right' }}>{(totalMinutesLocationSunday / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.zondag}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((totalMinutesLocationSunday / 60) * props.settings['uurloonlocatie' + user.postFix]) * props.settings.zondag, 2) / 100)} </td>
                        </tr>
                        <tr>
                            <td></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td>
                        </tr>
                        <tr>
                            <td>Opmerkingen</td><td colSpan="3"><TextField multiline value={remarks} style={{width:'100%'}} onChange={(ev)=>{setRemarks(ev.target.value)}}></TextField></td>
                        </tr>
                        <tr>
                            <td>Materiaal</td><td colSpan="3"><TextField multiline value={material}  style={{width:'100%'}}  onChange={(ev)=>{setMaterial(ev.target.value)}}></TextField></td>
                        </tr>
                        <tr>
                            <td></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td>
                        </tr>
                      
                        <tr>
                            <td>Totaal</td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}>{(Math.round(totalOverall * 100, 2) / 100)} </td>
                        </tr>
                          */
                        }

                        <tr><td></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td><td style={{ textAlign: 'right' }}></td></tr>
                        <tr><td colSpan="4">Opmerkingen</td></tr>
                        <tr><td colSpan="4"><TextField multiline value={remarks} style={{ width: '100%' }} onChange={(ev) => { setRemarks(ev.target.value) }}></TextField></td></tr>
                        <tr><td colSpan="3">Materiaal kosten</td><td><TextField type="number" value={materialCost} onChange={(ev) => { setMaterialCost(ev.target.value) }} style={{ width: '100%' }} inputProps={{ style: { textAlign: "right" } }}></TextField></td></tr>
                        <tr><td colSpan="4">Omschrijving materiaal</td></tr>
                        <tr><td colSpan="4"><TextField multiline value={material} style={{ width: '100%' }} onChange={(ev) => { setMaterial(ev.target.value) }}></TextField></td></tr>
                    </tbody>

                </table>
            </Paper>
            <br />

            {props.project.type === 1 && <Button variant="contained" color="primary" onClick={() => { setShowSendVisma(true); handleProjectInactive() }} style={{ width: '100%' }}>Doorsturen naar boekhoudpakket als concept factuur</Button>}
        </div>
    )
}
